import { gql, TypedDocumentNode, useSuspenseQuery } from '@apollo/client';
import { accountFragment } from './fragments';
import { Account, GetAccountsQuery, GetAccountsQueryVariables } from '../../generated/graphql';

export const accountsQuery: TypedDocumentNode<GetAccountsQuery, GetAccountsQueryVariables> = gql`
  query GetAccounts {
    accounts {
      ...AccountFragment
    }
  }
  ${accountFragment}
`;

export function useAccounts(): readonly Account[] {
  const { data } = useSuspenseQuery(accountsQuery, {});
  return data.accounts;
}
